import { render, staticRenderFns } from "./CurrentAndOtherBarrels.vue?vue&type=template&id=3b863065&"
import script from "./CurrentAndOtherBarrels.vue?vue&type=script&lang=ts&"
export * from "./CurrentAndOtherBarrels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports